export const AdGroupBidTypeNames = {
  0: 'CPC',
  1: 'CPM',
  2: 'CPV',
};
